import { emailSchema } from "@/schemas"
import { z } from "zod"

export const reSendSchema = z.object({
  email: emailSchema,
})

export type ReSendSchema = z.infer<typeof reSendSchema>
